import React from "react";
import CreateSchemaTool from "./CreateSchemaTool";
import DeleteSchemaTool from "./DeleteSchemaTool";
import FindSchemasTool from "./FindSchemasTool";
import OpenSchemaTool from "./OpenSchemaTool";
import UpdateSchemaTool from "./UpdateSchemaTool";
import type { ToolHelpers, ToolPartState } from "./types";

interface ToolPartLike {
    type: string;
    toolCallId: string;
    state: ToolPartState;
    input?: any;
    output?: any;
    errorText?: string;
}

export function renderToolPart(part: ToolPartLike, helpers: ToolHelpers): React.ReactNode {
    const common = {
        toolCallId: part.toolCallId,
        state: part.state,
        input: part.input,
        output: part.output,
        errorText: part.errorText,
        helpers,
    };
    switch (part.type) {
        case "tool-createSchema":
            return <CreateSchemaTool {...common} />;
        case "tool-findSchemas":
            return <FindSchemasTool {...common} />;
        case "tool-viewSchema":
            return <OpenSchemaTool {...common} mode="view" />;
        case "tool-editSchema":
            return <OpenSchemaTool {...common} mode="edit" />;
        case "tool-updateSchema":
            return <UpdateSchemaTool {...common} />;
        case "tool-deleteSchema":
            return <DeleteSchemaTool {...common} />;
        default:
            return null;
    }
}

export const KNOWN_TOOL_PART_TYPES = new Set<string>([
    "tool-createSchema",
    "tool-findSchemas",
    "tool-viewSchema",
    "tool-editSchema",
    "tool-updateSchema",
    "tool-deleteSchema",
]);
